import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import Select from '../../../Select/Select';
import { SelectValue } from '../../../Select';

interface Props extends BaseFieldProps {
	options: SelectValue[];
}

const SelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<Select options={props.options} displayErrorMessage={false} />
	</BaseField>
);

export default SelectField;
